module.exports = __webpack_public_path__ + "frontend-assets/img/games_icon.58d67477.png";